"use client"

import type { MouseEvent } from "react"

interface FooterRebrushCookiePreferencesLinkClientProps {
  label?: string
  className?: string
}

export default function FooterRebrushCookiePreferencesLinkClient({
  label,
  className,
}: FooterRebrushCookiePreferencesLinkClientProps) {
  function showCookiePreferences(event: MouseEvent<HTMLAnchorElement>) {
    event.preventDefault()
    window.OneTrust?.ToggleInfoDisplay()
  }

  return (
    <a href="#" onClick={showCookiePreferences} className={className}>
      {label}
    </a>
  )
}
